import { defineMessages } from 'react-intl';

export const apiKeysMessages = defineMessages({
    apiKeys: {
        id: 'api-keys',
        defaultMessage: 'API keys',
    },
    apiKey: {
        id: 'api-key',
        defaultMessage: 'API key',
    },
    createApiKeySuccess: {
        id: 'create-api-key-success',
        defaultMessage: 'API key created',
    },
    createApiKeySuccessDescription: {
        id: 'create-api-key-success-description',
        defaultMessage: 'API key has been successfully created.',
    },
    addApiKeySubtitle: {
        id: 'add-api-key-subtitle',
        defaultMessage: 'Add new API key',
    },
    createdAtApiKey: {
        id: 'created-at-api-key',
        defaultMessage: 'Created at',
    },
    deleteApiKeySuccess: {
        id: 'delete-api-key-success',
        defaultMessage: 'API key deleted',
    },
    deleteApiKeySuccessDescription: {
        id: 'delete-api-key-success-description',
        defaultMessage: 'API key {entry} has been successfully deleted.',
    },
    deleteApiKeySubtitle: {
        id: 'delete-api-key-subtitle',
        defaultMessage: 'Permanently delete API key {entry}',
    },
    confirmDeleteApiKey: {
        id: 'confirm-delete-api-key',
        defaultMessage: 'Are you sure you want to delete API key {entry}? This action cannot be undone.',
    },
    prefix: {
        id: 'prefix',
        defaultMessage: 'Prefix',
    },
    updateApiKeySuccess: {
        id: 'update-api-key-success',
        defaultMessage: 'API key updated',
    },
    updateApiKeySuccessDescription: {
        id: 'update-api-key-success-description',
        defaultMessage: 'API key {entry} has been successfully updated.',
    },
    editApiKeySubtitle: {
        id: 'edit-api-key-subtitle',
        defaultMessage: 'Edit API key {entry}',
    },
    copyNewApiKey: {
        id: 'copy-new-api-key',
        defaultMessage: 'Copy the new API key',
    },
});
